<template>
	<v-app light>
		<span id="top" />
		<div style="perspective: 100vmin; width:100vw; height:100vh; overflow-x:hidden; overflow-y:auto; position:fixed; top:0; -webkit-overflow-scrolling: touch;" id="frame">
		<!-- <div id="frame"> -->
			<!-- <header> -->
				<!-- medium + large toolbar -->
				<v-toolbar prominent flat fixed class="hidden-sm-and-down" style="backdrop-filter: blur(12px); background-color:rgba(255, 255, 255, 0.85); z-index: 1024; position:sticky; top:0; margin-bottom:-64px">
					<router-link to="/" style="margin-top:8px">
						<img v-bind:src="logo" :alt="logoAlt" @click="scrollToTop"/>
					</router-link>
					<v-spacer/>
					<v-layout wrap>
						<v-flex v-for="i in headerButtons" :key="i.path" @click="scrollToTop">
							<router-link v-if="i.path !== undefined" v-bind:to="i.path">
								<!-- <v-btn v-if="selectedHeaderButton === i.text" v-bind:class="[ colPrimary ]" stlye="height:16px">
									{{ i.text }}
								</v-btn>
								<v-btn v-else block flat v-bind:class="[ colPrimary ]" stlye="height:16px">
									{{ i.text }}
								</v-btn> -->
	
								<!-- <v-card v-if="selectedHeaderButton === i.text" :class="[ colPrimary ]" hover class="long-text uppercase pad-8">
									<span class="bold">{{ i.text }}</span>
								</v-card>
								<v-card v-else flat hover class="long-text uppercase pad-8 transparent">
									<span>{{ i.text }}</span>
								</v-card> -->
								
								<v-card flat :class=" {transparent: true, 'header-bar-button': true, 'header-bar-button-active': selectedHeaderButton === i.text }" style="padding: 8px">
									<!-- <span :style="(selectedHeaderButton === i.text ? 'opacity: 1.0;' : 'opacity: 0.5;') + 'text-transform: uppercase; font-weight: 700;'">{{ i.text }}</span> -->
									<span>{{ i.text }}</span>
									<div :class="colPrimary" :style="(selectedHeaderButton === i.text ? 'opacity: 1.0; transform: translateY(0px);' : 'opacity: 0.0; transform: translateY(5px);') + 'transition: all .3s ease; height: 3px;'"></div>
								</v-card>
							</router-link>
						</v-flex>
					</v-layout>
					<v-spacer/>
					<a :href="lng.shopLink" target="_blank">
						<v-btn color="green" outline round class="green--text">
							<span>{{ lng.openShop }}</span>
						</v-btn>
					</a>
					<div style="width: 16px" />
					<v-btn icon outline class="lang-button hidden-sm-and-down black--text" @click.native.stop="focusLanguageSwitcher();">
						{{ language }}
					</v-btn>
				</v-toolbar>
	
				<div style="background: linear-gradient(to bottom, rgba(0, 0, 0, 0.25), rgba(0, 0, 0, 0.0));
					position:sticky; top:64px; height:6px; margin-bottom:-6px; width:100%; z-index:512" class="hidden-sm-and-down" />

				<!-- language switcher -->
				<div class="lang-switcher-container top" tabindex="0" ref="lang-switcher" @click="() => { blurLanguageSwitcher(); }">
					<div class="lang-switcher">
						<div class="bar" />
						<div v-for="lang in languages" :key="lang.name">
							<div :class="[ 'button-stripe', colPrimary, (lang.name === language) ? 'button-stripe-selected' : '' ]" />
							<div :class="[ 'button', 'noselect', (lang.name === language) ? 'button-selected' : '' ]" @click="() => { setLanguage(lang.name, true); blurLanguageSwitcher(); }">
								{{ lang.title }}
							</div>

							<!-- <span v-if="lang.name === language">
								<v-list-tile @click.native="setLanguage(lang.name, true)" class="elevation-2" :class="colPrimary">
									<v-list-tile-title>{{ lang.title }}</v-list-tile-title>
								</v-list-tile>
							</span>
							<span v-else>
								<v-list-tile @click.native="setLanguage(lang.name, true)">
									<v-list-tile-title>{{ lang.title }}</v-list-tile-title>
								</v-list-tile>
							</span> -->
						</div>
						<div class="bar" />
					</div>
				</div>
	
				<!-- background toolbar -->
				<v-toolbar prominent flat class="hidden-xs-only">
					<v-spacer/>
					<img class="hidden-md-and-up" v-bind:src="logo" :alt="logoAlt"/>
					<v-spacer/>
					<a :href="lng.shopLink" target="_blank">
						<v-btn color="green" outline round class="green--text">
							<span>{{ lng.openShop }}</span>
						</v-btn>
					</a>
					<div style="width: 16px" />
					<div>
						<v-menu>
							<v-btn outline icon slot="activator">{{ language }}</v-btn>
	
							<v-list>
								<span v-for="lang in languages" :key="lang.name">
									<span v-if="lang.name === language">
										<v-list-tile @click.native="setLanguage(lang.name, true)" class="elevation-2" :class="colPrimary">
											<v-list-tile-title>{{ lang.title }}</v-list-tile-title>
										</v-list-tile>
									</span>
									<span v-else>
										<v-list-tile @click.native="setLanguage(lang.name, true)">
											<v-list-tile-title>{{ lang.title }}</v-list-tile-title>
										</v-list-tile>
									</span>
								</span>
							</v-list>
						</v-menu>
					</div>
				</v-toolbar>
	
				<!-- small toolbar -->
				<v-card class="hidden-md-and-up hidden-xs-only pad-8" v-bind:class="[ colPrimary ]">
					<v-spacer/>
					<v-layout wrap>
						<v-flex v-for="i in headerButtons" :key="i.path" @click="scrollToTop">
							<router-link v-if="i.path !== undefined" v-bind:to="i.path">
								<v-btn v-if="selectedHeaderButton === i.text" block>
									{{ i.text }}
								</v-btn>
								<v-btn v-else flat block>
									{{ i.text }}
								</v-btn>
	
								<!-- <v-card flat :class=" {transparent: true, 'header-bar-button': true, 'header-bar-button-active': selectedHeaderButton === i.text }" style="padding: 8px">
									<span>{{ i.text }}</span>
									<div :class="colPrimary" :style="(selectedHeaderButton === i.text ? 'opacity: 1.0; transform: translateY(0px);' : 'opacity: 0.0; transform: translateY(5px);') + 'transition: all .3s ease; height: 3px;'"></div>
								</v-card> -->
	
								<!-- <v-card v-if="selectedHeaderButton === i.text" hover class="long-text uppercase pad-8">
									<span class="bold">{{ i.text }}</span>
								</v-card>
								<v-card v-else flat hover class="long-text uppercase pad-8 transparent">
									<span>{{ i.text }}</span>
								</v-card> -->
							</router-link>
						</v-flex>
					</v-layout>
					<v-spacer/>
				</v-card>

				<!-- extra small toolbar -->
				<div class="hidden-sm-and-up xs-toolbar-background" />
				<div class="hidden-sm-and-up xs-toolbar">
					<div class="shadow" />
					<div style="position: absolute; right: 8px; z-index:1025">
						<v-menu>
							<v-btn icon dark slot="activator" style="text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);">{{ language }}</v-btn>
	
							<v-list>
								<span v-for="lang in languages" :key="lang.name">
									<span v-if="lang.name === language">
										<v-list-tile @click.native="setLanguage(lang.name, true)" class="elevation-2" :class="colPrimary">
											<v-list-tile-title>{{ lang.title }}</v-list-tile-title>
										</v-list-tile>
									</span>
									<span v-else>
										<v-list-tile @click.native="setLanguage(lang.name, true)">
											<v-list-tile-title>{{ lang.title }}</v-list-tile-title>
										</v-list-tile>
									</span>
								</span>
							</v-list>
						</v-menu>
					</div>
					<span>
						{{ siteName }}
					</span>
					<v-btn icon class="white--text" @click.native.stop="drawer = !drawer">
						<v-icon :class="[ 'icon', 'icon-menu', drawer ? '' : 'icon-active' ]">menu</v-icon>
						<v-icon :class="[ 'icon', 'icon-chev', drawer ? 'icon-active' : '' ]">chevron_left</v-icon>
					</v-btn>
				</div>

				<!-- navigation drawer -->
				<div :class="[ 'hidden-sm-and-up', 'nav-drawer-container', drawer ? 'nav-drawer-container-open' : 'nav-drawer-container-closed' ]">
					<div class="bg" @click="drawer = !drawer"/>
					<div :class="[ 'nav-drawer', drawer ? 'nav-drawer-open' : 'nav-drawer-closed' ]">
						<div style="padding-bottom:24px" />
						<div v-for="i in headerButtons" :key="i.path" @click="() => { scrollToTop(); closeDelay(1); }">
							<router-link v-if="i.path !== undefined" v-bind:to="i.path">
								<div :class="[ 'button', selectedHeaderButton === i.text ? 'button-selected' : '' ]">
									<div class="text">{{ i.text }}</div>
								</div>
							</router-link>
						</div>
						<div style="height:32px"/>
						<div style="display: block; padding: 0 64px;">
							<a :href="lng.shopLink" target="_blank">
								<v-btn block color="white" outline round class="white--text">
									<span>{{ lng.openShop }}</span>
								</v-btn>
							</a>
						</div>
						<!-- <v-menu style="position:absolute;top:100%;left:50%;transform:translate(-50%,-110px);">
							<v-btn dark wide outline slot="activator">{{ lng.language }}: {{ language }}</v-btn>

							<v-list>
								<span v-for="lang in languages" :key="lang.name">
									<span v-if="lang.name === language">
										<v-list-tile @click.native="setLanguage(lang.name, true)" class="elevation-2" :class="colPrimary">
											<v-list-tile-title>{{ lang.title }}</v-list-tile-title>
										</v-list-tile>
									</span>
									<span v-else>
										<v-list-tile @click.native="setLanguage(lang.name, true)">
											<v-list-tile-title>{{ lang.title }}</v-list-tile-title>
										</v-list-tile>
									</span>
								</span>
							</v-list>
						</v-menu> -->
						<div class="shadow" />
					</div>
				</div>
	
				<!-- extra small toolbar -->
				<!-- <v-toolbar fixed dark dense class="hidden-sm-and-up high-z-index"  v-bind:class="[ colPrimary ]" style="z-index: 1024; position:sticky; margin-bottom:-48px"> -->
					<!-- <v-btn icon v-tooltip:right="{ html: 'Sidebar öffnen' }" class="white--text" @click.native.stop="drawer = !drawer"> -->
						<!-- <v-icon>menu</v-icon> -->
					<!-- </v-btn> -->
					<!-- <v-spacer/> -->
					<!-- <v-toolbar-title>{{ siteName }}</v-toolbar-title> -->
					<!-- <v-spacer/> -->
				<!-- </v-toolbar> -->
	<!--  -->
				<!-- extra small background toolbar -->
				<!-- <v-toolbar flat dense class="hidden-sm-and-up"></v-toolbar> -->
	<!--  -->
				<!-- navigation drawer (for extra small) -->
				<!-- <v-card> -->
					<!-- <v-navigation-drawer persistent temporary disable-route-watcher v-model="drawer" class="hidden-md-and-up high-z-index"  style="backdrop-filter: blur(12px); background-color:rgba(64, 164, 64, 0.7);"> -->
						<!-- <v-btn icon v-tooltip:right="{ html: 'Sidebar schließen' }" class="white--text" @click.native.stop="drawer = !drawer"> -->
							<!-- <v-icon>menu</v-icon> -->
						<!-- </v-btn> -->
						<!-- <span v-for="i in headerButtons" :key="i.path" style="z-index:1024" @click="scrollToTop"> -->
							<!-- <router-link v-if="i.path !== undefined" v-bind:to="i.path"> -->
								<!-- <v-btn v-if="selectedHeaderButton === i.text" block large :ripple="false" @click.native="closeDelay(1)"> -->
									<!-- {{ i.text }} -->
								<!-- </v-btn> -->
								<!-- <v-btn v-else dark flat block :ripple="false" @click.native="closeDelay(150)"> -->
									<!-- {{ i.text }} -->
								<!-- </v-btn> -->
								<!-- <br> -->
							<!-- </router-link> -->
						<!-- </span> -->
					<!-- </v-navigation-drawer> -->
				<!-- </v-card> -->
	
				<!-- cookie law info -->
				<div v-if="showCookie" class="elevation-4">
					<v-toolbar flat dense class="warning">
						<div class="long-text" style="opacity:0.75">
							{{ lng.cookieMsg }}
						</div>
	
						<v-spacer class="hidden-sm-and-up"/>
	
						<a :href="lng.cookieLink" target="_blank">
							<v-btn flat small class="hidden-xs-only">
								<div style="opacity:0.65">
									{{ lng.whatAreCookies }}
								</div>
							</v-btn>
							<v-btn icon class="hidden-sm-and-up">
								<v-icon>help</v-icon>
							</v-btn>
						</a>
	
						<v-spacer class="hidden-xs-only"/>
	
						<v-btn icon @click.native="disableCookieInfo()">
							<v-icon>close</v-icon>
						</v-btn>
					</v-toolbar>
				</div>
	
				<!-- English WIP warning
				<div v-if="language === 'en'" class="long-text">
					<v-card flat class="pad-8" :class="[ colAccent ]">
						<v-card class="pad-8 warning img-center" style="max-width:1024px">
							<b class="bold">Warning:</b>
							The English translation is a work in progress. Some areas of the website may have not yet been translated.
							<v-btn small outline @click.native="setLanguage('de', true)" class="orange lighten-1">switch to German</v-btn>
						</v-card>
					</v-card>
				</div> -->
	
				<!-- page title -->
				<div v-if="pageName !== ''">
					<v-toolbar dark v-bind:class="[ colAccent ]">
						<v-toolbar-title>
							{{ pageName }}
						</v-toolbar-title>
					</v-toolbar>
				</div>
			<!-- </header> -->
	
			<!-- language switcher -->
			<!-- <div class="hidden-xs-only" style="z-index: 1025; position:sticky;">
				<v-menu style="z-index: 1025; position:sticky; top:0; right:0">
					<v-btn icon outline slot="activator" class="lang-button hidden-sm-and-down">{{ language }}</v-btn>
	
					<v-list>
						<span v-for="lang in languages" :key="lang.name">
							<span v-if="lang.name === language">
								<v-list-tile @click.native="setLanguage(lang.name, true)" class="elevation-2" :class="colPrimary">
									<v-list-tile-title>{{ lang.title }}</v-list-tile-title>
								</v-list-tile>
							</span>
							<span v-else>
								<v-list-tile @click.native="setLanguage(lang.name, true)">
									<v-list-tile-title>{{ lang.title }}</v-list-tile-title>
								</v-list-tile>
							</span>
						</span>
					</v-list>
				</v-menu>
			</div> -->
	
			<!-- <div style="perspective: 100vmin; width:100vw; height:100vh; overflowY:auto; overflowX:hidden; position:fixed; top:0;"> -->
			<!-- router view -->
			<router-view :language="language"/>
	
			<!-- footer -->
			<footer>
				<v-card v-if="showFooter" dark tile v-bind:class="[ colSecondary ]" style="padding: 24px;">
					<v-layout>
						<v-flex class="hidden-sm-and-down">
							<div v-for="i in headerButtons" :key="i.path">
								<router-link v-if="i.path !== undefined" v-bind:to="i.path">
									<button class="white--text">
										{{ i.text }}
									</button>
								</router-link>
							</div>
						</v-flex>
	
						<v-flex>
							Haplabit UG (haftungsbeschränkt)<br>
							Echterstrasse 8a<br>
							D-97209 Veitshoechheim<br>
							Dipl. – Ing. Harald Samoticha<br>
							+49 1522 8619 710<br>
							DE338177997<br>
						</v-flex>
	
						<v-flex>
							+49 1522 8619 710<br>
							<a href="mailto:info@hapla.eu" style="color:white">
								info@hapla.eu
							</a><br>
						</v-flex>
					</v-layout>
	
					<!-- language switcher -->
					<div>
						<v-menu>
							<v-btn dark outline slot="activator">{{ lng.language }}: {{ language }}</v-btn>
	
							<v-list>
								<span v-for="lang in languages" :key="lang.name">
									<span v-if="lang.name === language">
										<v-list-tile @click.native="setLanguage(lang.name, true)" class="elevation-2" :class="colPrimary">
											<v-list-tile-title>{{ lang.title }}</v-list-tile-title>
										</v-list-tile>
									</span>
									<span v-else>
										<v-list-tile @click.native="setLanguage(lang.name, true)">
											<v-list-tile-title>{{ lang.title }}</v-list-tile-title>
										</v-list-tile>
									</span>
								</span>
							</v-list>
						</v-menu>
					</div>
				</v-card>
			</footer>
		</div>
		<!-- </div> -->

		<!-- to top button -->
		<!-- <transition name="slide-fade-right"> -->
			<!-- <v-btn v-if="!isAtTop" fixed fab class="toTop grey lighten-3" @click.native="scrollToTop()"> -->
			<!-- <v-btn v-if="!isAtTop && $route.path != '/'" fixed fab class="toTop grey lighten-3" v-scroll-to="'#top'"> -->
				<!-- <v-icon> -->
					<!-- arrow_upward -->
				<!-- </v-icon> -->
			<!-- </v-btn> -->
		<!-- </transition> -->
	</v-app>
</template>

<script>
	export default {
		created: function() {
			this.$ga.page(this.$route.path);

			// cookie law info
			if (this.$cookie.get('cookieInfo') === null) {
				setTimeout(() => { this.showCookie = true; }, 10);
			}

			this.update();
			this.updateLng();

			setTimeout(() => { this.checkScroll(); }, 50);
		},
		updated: function() {
			// check for path change
			var path = this.$route.path;
			if (this.path !== path) {
				this.$ga.page(path);

				this.path = path;
				setTimeout(() => { this.update(); }, 50);
				window.scrollTo(0, 0);
			}
		},
    data: function () {
      return {
        path: '', // current path

        // page options
        pageName: 'no-name', // page name
        colPrimary: 'primary', // primary color
        colAccent: 'accent', // accent color
        colSecondary: 'secondary', // secondary color
        headerButtons: [], // array with header buttons
        selectedHeaderButton: '', // currently selected header button
        showFooter: true, // show footer
        siteName: 'Hapla', // name of the site
        logo: '/static/img/logo/haplabit_header.png', // logo image
        logoAlt: 'Hapla', // logo img alt

        // reloadedPath: '', // current path (used to reload the page)
        // 	reloadVisited: false, // whether a reload-page has been visited
        showCookie: false, // cookie law info
        drawer: false, // open sidebar
        closeDelay: function (delay) { // close the drawer after delay
          setTimeout(() => {
            this.drawer = false;
          }, delay);
        },
        getMeta: function (tag, val) { // does the route have a meta tag?
          return this.$route.meta[tag];
        },
        update: function () { // update
          // language
		  var lng = this.getMeta('lng');
		  if (lng === undefined) {
			  lng = this.language;
		  }
		  this.setLanguage(lng, false);

          // header buttons
          switch (this.getMeta('head')) {
            default:
            //   this.headerButtons = [
            //     // {text: 'Home', path: '/'},
            //     // {text: 'Prana', path: this.lng.header_functionality_prana_path},
            //     // {text: 'SolarFox', path: this.lng.header_functionality_solarfox_path},
            //     // {text: 'Termofol', path: this.lng.header_functionality_termofol_path},
            //     // {text: this.lng.header_order, path: this.lng.header_order_path},
			// 	// {text: this.lng.header_contact, path: this.lng.header_contact_path}
				
			// 	{ text: 'Home', path: '/' },
			// 	{ text: this.lng.header_docs, path: this.lng.header_docs_path },
			// 	// { text: 'Shop', path: '/shop' },
			// 	// { text: 'Download', path: '/download' },
			// 	{ text: this.lng.header_contact, path: this.lng.header_contact_path },
			//   ];
				this.headerButtons = [];
				this.$set(this.headerButtons, 0, { text: 'Home', path: '/' });
				this.$set(this.headerButtons, 1, { text: this.lng.header_offer, path: this.lng.header_offer_path });
				this.$set(this.headerButtons, 2, { text: this.lng.header_docs, path: this.lng.header_docs_path });
				this.$set(this.headerButtons, 3, { text: this.lng.header_contact, path: this.lng.header_contact_path });
				break;
            // case 'prana':
            //   this.headerButtons = [
            //     {text: 'Home', path: '/'},
            //     {text: this.lng.header_functionality, path: this.lng.header_functionality_prana_path},
            //     {text: this.lng.header_advantages, path: this.lng.header_advantages_prana_path},
            //     {text: this.lng.header_products, path: this.lng.header_products_prana_path},
            //     {text: this.lng.header_gallery, path: this.lng.header_gallery_prana_path},
            //     {text: this.lng.header_order, path: this.lng.header_order_path},
            //     {text: this.lng.header_contact, path: this.lng.header_contact_path}
            //   ];
            //   break;
            // case 'solar-fox':
            //   this.headerButtons = [
            //     {text: 'Home', path: '/'},
            //     {text: this.lng.header_functionality, path: this.lng.header_functionality_solarfox_path},
            //     {text: this.lng.header_advantages, path: this.lng.header_advantages_solarfox_path},
            //     {text: this.lng.header_products, path: this.lng.header_products_solarfox_path},
            //     {text: this.lng.header_gallery, path: this.lng.header_gallery_solarfox_path},
            //     {text: this.lng.header_order, path: this.lng.header_order_path},
            //     {text: this.lng.header_contact, path: this.lng.header_contact_path}
            //   ];
            //   break;
            // case 'termofol':
            //   this.headerButtons = [
            //     {text: 'Home', path: '/'},
            //     {text: this.lng.header_functionality, path: '/funktionsweise-termofol'},
            //     {text: this.lng.header_advantages, path: '/vorteile-termofol'},
            //     {text: this.lng.header_products, path: '/produkte-termofol'},
            //     {text: this.lng.header_order, path: this.lng.header_order_path},
            //     {text: this.lng.header_contact, path: this.lng.header_contact_path}
            //   ];
            //   break;
          }

          // set selected button
          var i = 0;
          while (i < this.headerButtons.length) {
            var path = this.headerButtons[i].path;
            if (path === "/") {
              if (path === this.$route.path) {
                this.selectedHeaderButton = this.headerButtons[i].text;
                break;
              }
            } else if (this.$route.path.indexOf(path) === 0) {
              this.selectedHeaderButton = this.headerButtons[i].text;
              break;
            }

            i++;
          }

          // page name
          this.pageName = this.$route.meta.name;

          // colors
          switch (this.getMeta('col')) {
            default:
              this.colPrimary = 'primary';
              this.colAccent = 'accent';
              this.colSecondary = 'secondary';
              break;
            case 1:
              this.colPrimary = 'primary-one';
              this.colAccent = 'accent-one';
              this.colSecondary = 'secondary-one';
              break;
            case 2:
              this.colPrimary = 'primary-two';
              this.colAccent = 'accent-two';
              this.colSecondary = 'secondary-two';
              break;
            case 3:
              this.colPrimary = 'primary-three';
              this.colAccent = 'accent-three';
              this.colSecondary = 'secondary-three';
              break;
          }

          // disable footer
          this.showFooter = this.getMeta('noFooter') !== true;

          // set site logo and name
          switch (this.getMeta('site')) {
            default:
              this.siteName = 'Hapla';
              this.logo = '/static/img/logo/haplabit_header.png';
              this.logoAlt = 'Hapla';
              break;
            // case 'prana':
            //   this.siteName = 'Prana';
            //   this.logo = '/static/img/logo/prana_header.png';
            //   this.logoAlt = 'Prana';
            //   break;
            // case 'solar-fox':
            //   this.siteName = 'Solar Fox';
            //   this.logo = '/static/img/logo/solar-fox_header.png';
            //   this.logoAlt = 'Solar-Fox';
            //   break;
            // case 'termofol':
            //   this.siteName = 'Termofol';
            //   this.logo = '/static/img/logo/termofol_header.png';
            //   this.logoAlt = 'Termofol';
            //   break;
          }

          // reload
          // if(this.reloadedPath !== this.$route.path) {
          // 	if(this.getMeta('reload') === true) {
          // 		if(this.reloadVisited) {
          // 			this.$router.go(0);
          // 		} else {
          // 			this.reloadVisited = true;
          // 		}
          // 	}
          // }
          // this.reloadedPath = this.$route.path;
        },
        disableCookieInfo: function () {
          this.$cookie.set('cookieInfo', '1337', {expires: '1Y'});
          this.showCookie = false;
        },

        // scroll to top
        scrollToTop: function () {
		//   window.scrollTo(0, 0);
			document.getElementById('frame').scrollTop = 0;
        },
        isAtTop: true,
        checkScroll: function () {
          setTimeout(() => {
            this.checkScroll();
          }, 500);

          this.isAtTop = window.scrollY <= 512;
		},
		
		// language switcher
		focusLanguageSwitcher: function() {
			let el = this.$refs['lang-switcher'];
			el.focus();
		},
		blurLanguageSwitcher: function() {
			let el = this.$refs['lang-switcher'];
			el.blur();
		},

        // language
        language: 'de',
        setLanguage: function (lang, performUpdate) {
          this.language = lang;
          this.updateLng();
          if (performUpdate) {
            this.update();
          }
        },
        languages: [
          { name: 'en', title: 'English' },
          { name: 'de', title: 'Deutsch' },
          { name: 'pl', title: 'Polski' },
		],
		replaceParams: function(input) {
			let matches = /\/:[^/]+/g.exec(input);

			if (matches === null) return input;

			matches.forEach(element => {
				let param = element.substr(2, element.length - 2);
				input = input.replace(element, '/' + this.$route.params[param]);
			});

			return input;
		},
        updateLng: function () {
          this.lng = this.messages[this.language];

          // set the path according to the current language
          if (this.$route.meta.lngPath !== undefined) {
			let path = this.$route.meta.lngPath[this.language];
			
			path = this.replaceParams(path);

            if (this.$route.path !== path) {
              this.$router.push(path);
            }
          }
        },
        lng: {},
        messages: {
          en: {
            language: 'Language',

            header_contact: 'Contact',
			header_contact_path: '/contact',
			header_docs: 'Documentation',
			header_docs_path: '/docs',
			header_offer: 'Offer',
			header_offer_path: '/offer',

            cookieMsg: 'We use Cookies.',
            whatAreCookies: 'What are Cookies?',
            cookieLink: 'https://en.wikipedia.org/wiki/HTTP_cookie',
			
			openShop: 'Open shop',
			shopLink: 'https://www.haplabit.shop/'
          },
          de: {
            language: 'Sprache',

            header_contact: 'Kontakt',
			header_contact_path: '/kontakt',
			header_docs: 'Dokumentation',
			header_docs_path: '/dokumentation',
			header_offer: 'Angebot',
			header_offer_path: '/angebot',

            cookieMsg: 'Diese Seite verwendet Cookies.',
            whatAreCookies: 'Was sind Cookies?',
            cookieLink: 'https://support.mozilla.org/de/kb/cookies-informationen-websites-auf-ihrem-computer',
			
			openShop: 'Shop öffnen',
			shopLink: 'https://www.haplabit.shop/'
		  },
		  pl: {
            language: 'język',

            header_contact: 'kontakt',
			header_contact_path: '/kontakt_pl',
			header_docs: 'dokumentacja',
			header_docs_path: '/dokumentacja',
			header_offer: 'oferta',
			header_offer_path: '/oferta',

            cookieMsg: 'Ta strona używa plików cookie.',
            whatAreCookies: 'Co to są pliki cookie?',
            cookieLink: 'https://support.mozilla.org/de/kb/cookies-informationen-websites-auf-ihrem-computer',
			
			openShop: 'do sklepu',
			shopLink: 'https://www.haplabit.shop/'
          }
        }
      }
    }
  }
</script>

<style>
body {
	/* overflow: hidden;
	overflow-x: hidden;
	overflow-y: hidden; */

	/* perspective: 100vmin;
	overflow-x:hidden;
	overflow-y:auto;
	top:0;
	-webkit-overflow-scrolling: touch; */
}

html {
	/* overflow: hidden;
	overflow-x: hidden;
	overflow-y: hidden; */
	overflow-y:hidden !important;
}

h1, h2, h3, h4, h5, h6 {
	display: block;
	margin: inherit;
	margin-top: inherit;
	margin-bottom: inherit;
	margin-left: inherit;
	margin-right: inherit;
	font-weight: inherit;
	letter-spacing: inherit;
	font-size: inherit;
	font: inherit;
}

a {
	text-decoration: none;
}

b {
	font-weight: 700;
}

.noselect {
  -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
     -khtml-user-select: none; /* Konqueror HTML */
       -moz-user-select: none; /* Old versions of Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
            user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Opera and Firefox */
}

.bold {
	font-weight: 700;
}

.long-text {
  /* font-family: 'Ubuntu', tahoma, arial, sans-serif; */
	font-weight: 400;
}

.heading-big {
	font-size: 32px;
	/* font-family: 'Ubuntu', tahoma, arial, sans-serif; */
	font-weight: 400;
}

.heading {
	font-size: 24px;
	/* font-family: 'Ubuntu', tahoma, arial, sans-serif; */
	font-weight: 400;
}

.heading-small {
	font-size: 16px;
	/* font-family: 'Ubuntu', tahoma, arial, sans-serif; */
	font-weight: 700;
}

.xs-toolbar-background {
	height: 48px;
	width: 100%;
	background-color: rgb(9, 189, 24);
	position: absolute;
}

.xs-toolbar {
	height: 48px;
	width: 100%;
	background-color: rgba(9, 189, 24, 0.829);
	backdrop-filter: blur(16px);
	position: sticky;
	top: 0;
	z-index: 1024;
}

.xs-toolbar .shadow {
	width: 100%;
	height: 4px;
	position: absolute;
	bottom: -4px;
	background: linear-gradient(to bottom, rgba(0, 0, 0, 0.35), rgba(0, 0, 0, 0.0));
	pointer-events: none;
}

.xs-toolbar .icon {
	position: absolute;
	text-shadow: 0 1px 2px rgba(0, 0, 0, 0.35);

	opacity: 0.0;
	transition: transform opacity 0.5s;
}

.xs-toolbar .icon-menu {
	transform: translateX(48px);
}

.xs-toolbar .icon-chev {
	transform: translateX(-48px);
}

.xs-toolbar .icon-active {
	transform: translateX(0);
	opacity: 1.0;
}

.xs-toolbar span {
	position: absolute;
	top: 50%;
	transform: translateY(-50%);
	width: 100%;
	text-align: center;
	color: white;
	font-size: 20px;
	text-shadow: 0 1px 2px rgba(0, 0, 0, 0.35);
}

.nav-drawer-container {
	width: 100vw;
	height: 100vh;

	transition: background 0.5s;

	position: sticky;
	margin-bottom: -100vh;
	z-index: 1024;
	top: 48px;
}

.nav-drawer-container-open {
	pointer-events: all;

	background-color: rgba(0, 0, 0, 0.5);
}

.nav-drawer-container-closed {
	pointer-events: none;

	background-color: rgba(0, 0, 0, 0.0);
}

.nav-drawer-container .nav-drawer {
	height: 100vh;
	width: 65vw;
	backdrop-filter: blur(12px);
	background-color:rgba(64, 164, 64, 0.7);

	transition: all 0.35s;
}

.nav-drawer-container .nav-drawer-open {
	pointer-events: all;
	transform: translateX(0);
}

.nav-drawer-container .nav-drawer-closed {
	pointer-events: none;
	backdrop-filter: blur(0px);
	transform: translateX(-100%);
}

.nav-drawer-container .nav-drawer .button {
	/* height: 64px; */
	width: 100%;
	/* padding-left: 24px; */
	padding-top: 16px;
	padding-bottom: 16px;
	padding-left: 24px;
	padding-right: 24px;

	transition: 0.2s;
}

.nav-drawer-container .nav-drawer .button:active {
	background: rgba(255, 255, 255, 0.45);
}

.nav-drawer-container .nav-drawer .button:hover {
	background: rgba(255, 255, 255, 0.2);
}

.nav-drawer-container .nav-drawer .button .text {
	color: rgba(255, 255, 255, 0.87);
	text-transform: uppercase;
	font-weight: 700;
	font-size: 16px;
	text-shadow: 0 1px 2px rgba(0, 0, 0, 0.35);
}

.nav-drawer-container .nav-drawer .button-selected {
	background: rgba(255, 255, 255, 0.35);
}

.nav-drawer-container .nav-drawer .button .text {
	color: white;
}

.nav-drawer-container .nav-drawer .shadow {
	height: 100vh;
	width: 6px;
	position: absolute;
	right: -6px;
	top: 0;

	background: linear-gradient(to right, rgba(0, 0, 0, 0.35), rgba(0, 0, 0, 0));

	transition: opacity 0.5s;
}

.nav-drawer-container .bg {
	width: 100vw;
	height: 100vh;
	position: absolute;
}

.nav-drawer-container .nav-drawer-closed .shadow {
	opacity: 0;
}

.nav-drawer-container .lang-button {
	position: absolute;
	bottom: 10px;
}

.header-bar-button {
	text-transform: uppercase;
	font-weight: 700;
	transition: all .3s ease;
	opacity: 0.5;
}

.header-bar-button:hover {
	opacity: 1.0;
}

.header-bar-button-active {
	opacity: 1.0;
}

.shop-button {
	color: green;
	border-style: solid;
	text-transform: uppercase;
	font-weight: 700;
	transition: all .3s ease;
	opacity: 0.5;
}

.shop-button:hover {
	opacity: 1.0;
}

@media (max-width: 599px) {
	.top {
		top: 48px;
	}
}

@media (max-width: 1023px) and (min-width: 600px) {
	.top {
		top: 0px;
	}
}

@media (min-width: 1024px) {
	.top {
		top: 64px;
	}
}

.auto-scale {
	max-width: 100%;
	max-height: 100%;
	min-width: 100%;
	min-height: 100%;
}

.auto-downscale {
	max-width: 100%;
	max-height: 100%;
}

.img-center {
	display: block;
	margin: auto;
}

.pre-wrap {
	white-space: pre-wrap;
}

.pad-8 {
	padding: 8px;
}

.pad-16 {
	padding: 16px;
}

.pad-32 {
	padding: 32px;
}

.pad-64 {
	padding: 64px;
}

.toTop {
	z-index: 1024;
	right: 16px;
	bottom: 32px;
}

.sticky {
	position: sticky;
	top: 0;
}

.lang-button {
	/* z-index: 1024;
	position: sticky !important;
	right: 16px;
	top: 16px; */

	opacity: 0.5;
}

.lang-switcher-container {
	position: sticky;
	z-index: 1025;
	height: 192px;
	margin-bottom: -192px;
	width: 100%;
	opacity: 0;
	pointer-events: none;

	transition: opacity 0.2s;
}

.lang-switcher-container:focus {
	position: sticky;
	z-index: 1025;
	height: 192px;
	margin-bottom: -192px;
	width: 100%;
	outline: 0;
	pointer-events: unset;

	opacity: 1.0;

	transition: opacity 0.1s;
}

.lang-switcher-container .lang-switcher {
	position: absolute;
	right: 0;
	z-index: 1025;
	width: 256px;
	height: 192px;

	/* background-color: rgba(247, 247, 247, 0.8); */
	backdrop-filter: blur(8px);

	border-radius: 0 0 0 8px;
	overflow: hidden;
	box-shadow: -3px 3px 6px rgba(0, 0, 0, 0.35);
}

.lang-switcher-container .lang-switcher .bar {
	width: 100%;
	height: 24px;
	background-color: rgba(235, 235, 235, 0.9);
}

.lang-switcher-container .lang-switcher .button {
	width: 100%;
	height: 48px;
	padding-left: 48px;
	/* padding-bottom: 32px; */
	padding-top: 14px;
	font-size: 16px;
	font-weight: 500;
	color: rgba(0, 0, 0, 0.75);
	cursor: pointer;

	/* background: rgba(251, 251, 255, 0.8); */
	background-color: rgba(235, 235, 235, 0.9);

	transition: 0.1s;
}

.lang-switcher-container .lang-switcher .button:hover {
	background-color: rgba(212, 212, 212, 0.9);
}

.lang-switcher-container .lang-switcher .button:active {
	background-color: rgba(182, 182, 182, 0.9);
}

.lang-switcher-container .lang-switcher .button-selected {
	background: rgb(252, 252, 252);
	box-shadow: 0 1px 4px rgba(0, 0, 0, 0.25);
}

.lang-switcher-container .lang-switcher .button-selected:hover {
	background: rgb(252, 252, 252);
}

.lang-switcher-container .lang-switcher .button-stripe {
	width:4px;
	height:48px;
	position:absolute;
	/* background-color:rgb(92, 197, 21); */

	opacity: 0.0;
	transition: 0.1s;
}

.lang-switcher-container .lang-switcher .button-stripe-selected {
	opacity: 1.0;
}

.lang-button:hover {
	opacity: 1.0;
}

.high-z-index {
	z-index: 1024;
}

.uppercase {
	text-transform: uppercase;
}

/* .transparent {
	background: rgba(0, 0, 0, 0);
} */

.float-left {
	float: left;
}

.absolute {
	position: absolute;
}

.slide-fade-right-enter-active {
	transition: all 1s cubic-bezier(.77,-0.09,.23,1.34);
}
.slide-fade-right-leave-active {
	transition: all .1s ease;
}
.slide-fade-right-enter {
	transform: translateX(40px);
	opacity: 0;
}
.slide-fade-right-leave-to {
	transform: translateX(10px);
	opacity: 0;
}
</style>

<style lang="stylus">
	@import './stylus/main'
</style>



// WEBPACK FOOTER //
// App.vue?5b57e010